import { useEffect, useState } from 'react';

/** `value`, once it has stopped changing for `delayMs`: what a type-ahead
 *  search keys its request on, so each keystroke does not send one. */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
